// extracted by mini-css-extract-plugin
export default {"container":"error_container__1hVQM","title":"error_title__2Rs8s","content":"error_content__2oEje","actions":"error_actions__1jCE6"};